import React, { useEffect, useMemo, useState } from "react";

import "./ChartEditor.css";

import ChartRenderer from "./ChartRenderer";
import BuilderTabs from "../../Layouts/BuilderTabs";
import ChartTheme from "./Theme/ChartTheme";
import DropShadow from "./Shadow/DropShadow";
import Axis from "./Axis/Axis";
import GridLinesSettings from "./GridLines/GridLineSettings";
import ChartSettings from "./ChartSettings/ChartSettings";
import CHart from "./ChartFill/CHartFill";
import Legend from "./Legend/Legend";
import DataLabels from "./DataLabels/DataLabels";
import Button from "../../components/FormComponents/Button";
import { useAxiosContext } from "../../context/AxiosContext";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../Layouts/Loader/Loader";

const ChartEditor = () => {
  const params = useParams();
  const location = useLocation();
  const { axiosInstance, handleSuccess, handleError } = useAxiosContext();

  const chartId = location.state;

  const [chartConfig, setChartConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [chartName, setChartName] = useState(null);

  let tabData;
  if (!isLoading)
    tabData = [
      {
        label: "Chart Theme",
        content: (
          <div>
            <ChartTheme setChartConfig={setChartConfig} chartConfig={chartConfig} />
            <DropShadow setChartConfig={setChartConfig} chartConfig={chartConfig} />
          </div>
        )
      },
      {
        label: "Axes / Grid",
        content: (
          <div>
            <Axis setChartConfig={setChartConfig} axisConfig={chartConfig.xaxis} axisType={"xaxis"} />

            <Axis setChartConfig={setChartConfig} axisConfig={chartConfig.yaxis} axisType={"yaxis"} />

            <GridLinesSettings setChartConfig={setChartConfig} grid={chartConfig.grid} />
          </div>
        )
      },
      {
        label: "Chart Options",
        content: <ChartSettings chartConfig={chartConfig} setChartConfig={setChartConfig} />
      },
      {
        label: "Chart Fill",
        content: <CHart setChartConfig={setChartConfig} chartConfig={chartConfig} />
      },
      {
        label: "Legend",
        content: <Legend setChartConfig={setChartConfig} chartConfig={chartConfig} />
      },
      {
        label: "Data Labels",
        content: <DataLabels setChartConfig={setChartConfig} chartConfig={chartConfig} />
      }
    ];

  const handleChartSave = async () => {
    try {
      const { message } = await axiosInstance.put(`/charts/sysconfigs/${chartId}`, {
        config: chartConfig
      });
      handleSuccess(message);
    } catch (error) {
      handleError(error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);

    const { data } = await axiosInstance.get(`/charts/sysconfigs/${chartId}`);
    setChartConfig(data.config);
    setChartName(data.name);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();

    //eslint-disable-next-line
  }, []);

  //because any change inside chart wont reflect in the original object
  const chartConfigClone = useMemo(() => {
    return chartConfig ? structuredClone(chartConfig) : {};
  }, [chartConfig]);

  return (
    <div className="application_container">
      <AppLeftSideBar type={params.orgId ? "app" : "org"} />
      <div className="dashboard_outer_section charts">
        {isLoading ? (
          <Loader />
        ) : (
          <div className="chart-editor">
            <div className="flex_column">
              <h2 className="mb_2 p_4">Chart Theme Builder - {chartName}</h2>
              <div className="d_flex w_100 flex_wrap">
                <ChartRenderer config={chartConfigClone} type="pie" />
                <ChartRenderer config={chartConfigClone} type="donut" />
                <ChartRenderer config={chartConfigClone} type="line" />
                <ChartRenderer config={chartConfigClone} type="bar" />
              </div>
            </div>

            <div style={{ position: "relative", backgroundColor: "var(--builder-tab-bg)" }}>
              <div className="flex_column">
                <BuilderTabs tabs={tabData} contentClass="chart-editor-content" />

                <div className="d_flex w_100">
                  <Button title="Save" className="mt_2 ml_4" onClick={handleChartSave}>
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartEditor;
